import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import service from "../services/permiso.service";

const initialState = {
    permisos: [],
    isLoading: false,
    isError: false,
    message: '',// Mensaje de error general
    currentPage: 1,
    totalRows: 0
};


export const getPermisos = createAsyncThunk(
    "permisos/getPermisos",
    async (data, thunkAPI) => {
        try {
            return await service.getAllPermisos(data);
        } catch (error) {
            const message = 
            (error.response && 
                error.response.data && 
                error.response.data.message) || 
                error.message || 
                error.toString();
            return thunkAPI.rejectWithValue(message);
        }
    }
);
export const createPermiso = createAsyncThunk(
    "permiso/create",
    async (permisoData, thunkAPI) => {
        try {
            return await service.createPermiso(permisoData);
        } catch (error) {
            const message = 
            (error.response && 
                error.response.data && 
                error.response.data.message) || 
                error.message || 
                error.toString();
            return thunkAPI.rejectWithValue(message);
        }
    }
);
export const updatePermiso = createAsyncThunk(
    "permiso/update",
    async (permisoData, thunkAPI) => {
        try {
            return await service.updatePermiso(permisoData);
        } catch (error) {
            const message = 
            (error.response && 
                error.response.data && 
                error.response.data.message) || 
                error.message || 
                error.toString();
            return thunkAPI.rejectWithValue(message);
        }
    }
);
export const deletePermiso = createAsyncThunk(
    "permiso/delete",
    async (id, thunkAPI) => {
        try {
            return await service.deletePermiso(id);
        } catch (error) {
            const message = 
            (error.response && 
                error.response.data && 
                error.response.data.message) || 
                error.message || 
                error.toString();
            return thunkAPI.rejectWithValue(message);
        }
    }
);

const permisoSlice = createSlice({
    name: "permiso",
    initialState,
    reducers: {
        reset: (state) => {
            state.permisos = [];
            state.isLoading = false;
            state.isError = false;
            state.message = '';
            state.currentPage = 1;
            state.totalRows = 0;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getPermisos.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(getPermisos.fulfilled, (state, action) => {
                state.isLoading = false;
                state.permisos = action.payload.data; // Asignar los permisos obtenidos
                state.currentPage = action.payload.pagination.currentPage; // Actualizar la página actual
                state.totalRows = action.payload.pagination.totalRows; // Actualizar el total de filas
                state.isError = false;
                state.message = '';
            })
            .addCase(getPermisos.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.message = action.payload || 'Error al obtener los permisos';
            })
            .addCase(createPermiso.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(createPermiso.fulfilled, (state, action) => {
                state.isLoading = false;
                state.permisos.push(action.payload);
                state.isError = false;
                state.message = 'Permiso creado correctamente';
            })
            .addCase(createPermiso.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.message = action.payload || 'Error al crear el permiso';
            })
            .addCase(updatePermiso.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(updatePermiso.fulfilled, (state, action) => {
                const index = state.permisos.findIndex(permiso => permiso.id === action.payload.id);
                if (index !== -1) {
                    state.permisos[index] = action.payload; // Actualizar el permiso modificado
                }
                state.isLoading = false;
                state.isError = false;
                state.message = 'Permiso actualizado correctamente';
            })
            .addCase(updatePermiso.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.message = action.payload || 'Error al actualizar el permiso';
            })
            .addCase(deletePermiso.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(deletePermiso.fulfilled, (state, action) => {
                state.permisos = state.permisos.filter(permiso => permiso.id !== action.payload.id); // Eliminar el permiso
                state.isLoading = false;
                state.isError = false;
                state.message = 'Permiso eliminado correctamente';
            })
            .addCase(deletePermiso.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.message = action.payload || 'Error al eliminar el permiso';
            });
    }
});
export const { reset } = permisoSlice.actions;
export default permisoSlice.reducer;